import { gql } from "@apollo/client";

const PUBLISH_BRAND_GRAPH = gql`
  mutation PublishBrandGraph($graphId: ID!, $userId: ID!, $campaignIds: [ID!]!) {
    publishBrandGraph(graphId: $graphId, userId: $userId, campaignIds: $campaignIds)
  }
`;

export default PUBLISH_BRAND_GRAPH;
